import React, { useEffect, useState } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import Dashboard from "./Pages/Dashboard";
import Sales from "./Pages/Sales";
import MainLayout from "./Components/Layout/MainLayout";
import ApplicationReport from "./Pages/ApplicationReport";
import SalesReport from "./Pages/SalesReport";
import ManageUsers from "./Pages/ManageUsers";
import PurchaseOrderReport from "./Pages/PurchaseOrderReport";
import ProductSalesReport from "./Pages/ProductSalesReport";
import ProductLeadReport from "./Pages/ProductLeadReport";
import CustomerVisit from "./Pages/CustomerVisit";
import Visit from "./Pages/Visit";
import SalesVsProduct from "./Pages/SalesVsProduct";
import SignIn from "./Pages/SignIn";
import ImageLoader from "./Pages/Loader";

const App = () => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [activeUser, setActiveUser] = useState({});

  useEffect(() => {
    const authStatus = localStorage.getItem("isAuthenticated") === "true";
    const storedUser = localStorage.getItem("user");

    if (authStatus && storedUser) {
      setUser(JSON.parse(storedUser));
      setIsAuthenticated(true);
    }

    setTimeout(() => {
      setLoading(false);
    }, 500); 
  }, []);

  const userData = user || activeUser;

  if (loading) {
    return <ImageLoader />;
  }

  return (
    <Routes>
      <Route
        path="/"
        element={<Navigate to={isAuthenticated ? "/dashboard" : "/signin"} />}
      />
      <Route
        path="/signin"
        element={<SignIn setActiveUser={setActiveUser} />}
      />

      {userData && (
        <Route element={<MainLayout user={userData} />}>
          <Route
            path="/dashboard"
            element={<Dashboard userRole={userData.userRole} />}
          />
          <Route path="/sales" element={<Sales userRole={userData.userRole} />} />
          <Route
            path="/dashboard/SalesVsProducts"
            element={<SalesVsProduct />}
          />
          <Route
            path="/application-report"
            element={<ApplicationReport userRole={userData.userRole} />}
          />
          <Route
            path="/sales-report"
            element={<SalesReport userRole={userData.userRole} />}
          />
          <Route
            path="/purchase-order-report"
            element={
              <PurchaseOrderReport userRole={userData.userRole} user={userData} />
            }
          />
          <Route path="/manage-users" element={<ManageUsers />} />
          <Route path="/product-sales-report" element={<ProductSalesReport />} />
          <Route path="/product-lead-report" element={<ProductLeadReport />} />
          <Route path="/customer-visit" element={<CustomerVisit userRole={userData.userRole} />} />
          <Route path="/visit" element={<Visit />} />
        </Route>
      )}

      <Route
        path="*"
        element={<Navigate to={isAuthenticated ? "/dashboard" : "/signin"} />}
      />
    </Routes>
  );
};

export default App;
